import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycElderLawPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-elder-law/']} />;
}
